export default {
	form: [
		[
			{
				locationKey: 'checkbox_1',
				remark: '',
				mustAnswer: 1,
				questionType: '12',
				layoutType: 1,
				optionList: [
					{
						name: '家属',
						orderNum: 1
					},
					{
						name: '护工/保姆',
						defaultFlag: 0,
						key: 'M_1658215599394',
						orderNum: 3
					},
					{
						name: '自我照护',
						defaultFlag: 0,
						key: 'M_1658215600541',
						orderNum: 4
					},
					{
						name: '其他',
						defaultFlag: 0,
						key: 'M_1658215617176',
						orderNum: 5
					}
				],
				name: '1.您的主要照护者（多选）',
				value: [],
				show: []
			},
			{
				locationKey: 'radio_2',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				optionList: [
					{
						name: '正常工作',
						defaultFlag: 0
					},
					{
						name: '出勤减少',
						defaultFlag: 0
					},
					{
						name: '不工作',
						defaultFlag: 0
					}
				],
				layoutType: 1,
				name: '2.您目前工作情况',
				value: '',
				orderNum: 9,
				show: []
			},
			{
				locationKey: 'radio_3',
				remark: '',
				mustAnswer: 1,
				questionType: '12',
				layoutType: 1,
				name: '3.随访期间您是否新发以下疾病事件',
				optionList: [
					{
						name: '卒中',
						orderNum: 1,
						ext: [
							{
								type: 'date',
								value: '',
								mustAnswer: 0,
								label: '发病时间'
							}
						]
					},
					{
						name: '短暂性脑缺血发作（TIA) ',
						orderNum: 1,
						ext: [
							{
								type: 'date',
								value: '',
								mustAnswer: 0,
								label: '发病时间'
							}
						]
					},
					{
						name: '不稳定心绞痛',
						orderNum: 1,
						ext: [
							{
								type: 'date',
								value: '',
								mustAnswer: 0,
								label: '发病时间'
							}
						]
					},
					{
						name: '心衰（住院)',
						orderNum: 1,
						ext: [
							{
								type: 'date',
								value: '',
								mustAnswer: 0,
								label: '发病时间'
							}
						]
					},
					{
						name: '房颤',
						orderNum: 1,
						ext: [
							{
								type: 'date',
								value: '',
								mustAnswer: 0,
								label: '发病时间'
							}
						]
					},
					{
						name: '其他',
						defaultFlag: 0,
						ext: [
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								textAlign: 'left'
							}
						]
					},
					{
						name: '以上均无',
						defaultFlag: 0,
						setting: {
							type: 'clear'
						}
					}
				],
				value: [],
				orderNum: 3,
				show: []
			},
			{
				locationKey: 'radio_4',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				name: '4.您现在有无吸烟',
				optionList: [
					{
						name: '不吸烟',
						defaultFlag: 0,
						key: 1,
						orderNum: 1
					},
					{
						name: '已戒烟',
						defaultFlag: 0,
						key: 2,
						orderNum: 2
					},
					{
						name: '现在吸烟',
						defaultFlag: 0,
						key: 2,
						orderNum: 2
					}
				],
				layoutType: 1,
				value: '',
				orderNum: 9,
				show: []
			},
			{
				locationKey: 'checkbox_5_1',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				layoutType: 1,
				name: '4.1.日吸烟量（支）',
				optionList: [
					{
						name: '＜5支',
						orderNum: 1
					},
					{
						name: '5-10支',
						orderNum: 2
					},
					{
						name: '10-20支',
						defaultFlag: 0
					},
					{
						name: '＞20支',
						defaultFlag: 0
					}
				],
				value: [],
				orderNum: 3,
				show: [
					{
						questionId: 'radio_4',
						answer: '现在吸烟'
					}
				]
			},
			{
				locationKey: 'radio_5',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				name: '5.您现在有无饮酒',
				optionList: [
					{
						name: '不饮酒',
						defaultFlag: 0,
						key: 1,
						orderNum: 1
					},
					{
						name: '已戒酒',
						defaultFlag: 0,
						key: 2,
						orderNum: 2
					},
					{
						name: '偶尔饮酒',
						defaultFlag: 0,
						key: 4,
						orderNum: 2
					},
					{
						name: '经常饮酒（≥3次/周，≥2两/次）',
						defaultFlag: 0,
						key: 3,
						orderNum: 2
					}
				],
				layoutType: 1,
				value: '',
				orderNum: 9,
				show: []
			},
			{
				locationKey: 'radio_6',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				name: '6.您有无进行体育锻炼',
				optionList: [
					{
						name: '经常运动（相当于快步走的中强度运动且每周≥3次、每次≥30分钟）或重体力劳动（含工农业劳动者)',
						defaultFlag: 0,
						key: 1,
						orderNum: 1
					},
					{
						name: '缺乏运动或轻体力劳动者(锻炼次数<3次/周且<30分钟/次)',
						defaultFlag: 0,
						key: 2,
						orderNum: 2
					}
				],
				layoutType: 1,
				value: '',
				orderNum: 9,
				show: []
			},
			{
				locationKey: 'radio_7',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				name: '7.您是否有高血压',
				optionList: [
					{
						name: '是（含既往及本次随访期间新发现的高血压）',
						defaultFlag: 0
					},
					{
						name: '否',
						defaultFlag: 0
					}
				],
				layoutType: 1,
				value: '',
				show: []
			},
			{
				locationKey: 'radio_7_1',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				name: '7.1.您的血压测量频率',
				optionList: [
					{
						name: '每周测量(≥3次/周 )',
						defaultFlag: 0
					},
					{
						name: '每周测量(1-2次/周)',
						defaultFlag: 0
					},
					{
						name: '每月测量（1-2次/月）',
						defaultFlag: 0
					},
					{
						name: '不定期测量',
						defaultFlag: 0
					},
					{
						name: '未测',
						defaultFlag: 0
					}
				],
				layoutType: 1,
				value: '',
				show: [
					{
						questionId: 'radio_7',
						answer: '是（含既往及本次随访期间新发现的高血压）'
					}
				]
			},
			{
				locationKey: 'radio_7_2',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				name: '7.2.平时血压水平',
				optionList: [
					{
						name: '＜120/80mmHg',
						defaultFlag: 0
					},
					{
						name: '120-139/80-89mmHg',
						defaultFlag: 0
					},
					{
						name: '140-159/90-99mmHg',
						defaultFlag: 0
					},
					{
						name: '160-179/100-109mmHg',
						defaultFlag: 0
					},
					{
						name: '≥180/110mmHg',
						defaultFlag: 0
					},
					{
						name: '不详',
						defaultFlag: 0
					}
				],
				layoutType: 1,
				value: '',
				show: [
					{
						questionId: 'radio_7',
						answer: '是（含既往及本次随访期间新发现的高血压）'
					}
				]
			},
			{
				locationKey: 'radio_7_3',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				name: '7.3.您是否服用降压药物',
				optionList: [
					{
						name: '是',
						defaultFlag: 0
					},
					{
						name: '否',
						defaultFlag: 0
					}
				],
				layoutType: 1,
				value: '',
				show: [
					{
						questionId: 'radio_7',
						answer: '是（含既往及本次随访期间新发现的高血压）'
					}
				]
			},
			{
				locationKey: 'fuse_7_3_1',
				remark: '',
				mustAnswer: 1,
				questionType: '24',
				layoutType: 1,
				name: '7.3.1.您服用的降压药',
				optionList: [
					[
						{
							name: '药物名称：',
							value: '',
							mustAnswer: 1,
							suffixName: ''
						},
						{
							name: '每次剂量：',
							value: '',
							mustAnswer: 0,
							suffixName: 'mg'
						},
						{
							name: '服药频率：',
							value: '',
							type: 'picker',
							columns: [1, 2, 3, 4],
							mustAnswer: 0,
							suffixName: '次/天'
						}
					]
				],
				value: [],
				orderNum: 3,
				show: [
					{
						questionId: 'radio_7_3',
						answer: '是'
					}
				]
			},
			{
				locationKey: 'radio_8',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				name: '8.您是否有糖尿病',
				optionList: [
					{
						name: '是',
						defaultFlag: 0
					},
					{
						name: '否',
						defaultFlag: 0
					}
				],
				layoutType: 1,
				value: '',
				show: []
			},
			{
				locationKey: 'radio_8_1',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				name: '8.1.您的血糖测量频率',
				optionList: [
					{
						name: '每周测量(≥3次/周 )',
						defaultFlag: 0
					},
					{
						name: '每周测量(1-2次/周)',
						defaultFlag: 0
					},
					{
						name: '每月测量（1-2次/月）',
						defaultFlag: 0
					},
					{
						name: '不定期测量',
						defaultFlag: 0
					},
					{
						name: '未测',
						defaultFlag: 0
					}
				],
				layoutType: 1,
				value: '',
				show: [
					{
						questionId: 'radio_8',
						answer: '是'
					}
				]
			},
			{
				locationKey: 'radio_8_2',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				name: '8.2.平时血糖水平',
				optionList: [
					{
						name: '空腹＜7mmol/L、餐后2小时＜11.1mmol/L',
						defaultFlag: 0
					},
					{
						name: '空腹≥7.1mmol/L、餐后2小时≥11.1mmol/L',
						defaultFlag: 0
					},
					{
						name: '不详',
						defaultFlag: 0
					}
				],
				layoutType: 1,
				value: '',
				show: [
					{
						questionId: 'radio_8',
						answer: '是'
					}
				]
			},
			{
				locationKey: 'radio_8_3',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				name: '8.3.您是否服用降糖药',
				optionList: [
					{
						name: '是',
						defaultFlag: 0
					},
					{
						name: '否',
						defaultFlag: 0
					}
				],
				layoutType: 1,
				value: '',
				show: [
					{
						questionId: 'radio_8',
						answer: '是'
					}
				]
			},
			{
				locationKey: 'fuse_8_3_1',
				remark: '',
				mustAnswer: 1,
				questionType: '24',
				layoutType: 1,
				name: '8.3.1.您服用的降糖药（如有）',
				optionList: [
					[
						{
							name: '药物名称：',
							value: '',
							mustAnswer: 1,
							suffixName: ''
						},
						{
							name: '每次剂量：',
							value: '',
							mustAnswer: 0,
							suffixName: 'mg'
						},
						{
							name: '服药频率：',
							value: '',
							type: 'picker',
							columns: [1, 2, 3, 4],
							suffixName: '次/天'
						}
					]
				],
				value: [],
				orderNum: 3,
				show: [
					{
						questionId: 'radio_8_3',
						answer: '是'
					}
				]
			},
			{
				locationKey: 'fuse_8_3_2',
				remark: '',
				mustAnswer: 0,
				questionType: '24',
				layoutType: 1,
				hideAdd: true,
				name: '8.3.2.您使用的胰岛素（如有）',
				optionList: [
					[
						{
							name: '胰岛素名称：',
							value: '',
							mustAnswer: 0,
							suffixName: ''
						},
						{
							name: '每次剂量：',
							value: '',
							mustAnswer: 0,
							suffixName: 'U'
						},
						{
							name: '注射频率：',
							value: '',
							mustAnswer: 0,
							type: 'picker',
							columns: [1, 2, 3, 4],
							suffixName: '次/天'
						}
					]
				],
				value: [],
				orderNum: 3,
				show: [
					{
						questionId: 'radio_8_3',
						answer: '是'
					}
				]
			},
			{
				locationKey: 'radio_9',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				name: '9.您是否有血脂异常',
				optionList: [
					{
						name: '是（含既往及本次随访期间新发现的血脂异常）',
						defaultFlag: 0
					},
					{
						name: '否',
						defaultFlag: 0
					}
				],
				layoutType: 1,
				value: '',
				show: []
			},
			{
				locationKey: 'input_9_1',
				remark: '',
				mustAnswer: 0,
				questionType: '21',
				showDateFormat: 'yyyy-MM-dd',
				name: '9.1.您目前的血脂水平（最近一次的测量值）',
				optionList: [
					{
						name: '总胆固醇（mmol/L）',
						suffixName: '',
						layoutType: 2,
						value: ''
					},
					{
						name: '低密度脂蛋白胆固醇（mmol/L）',
						suffixName: '',
						layoutType: 2,
						value: ''
					},
					{
						name: '甘油三酯（mmol/L）',
						suffixName: '',
						layoutType: 2,
						value: ''
					},
					{
						name: '高密度脂蛋白胆固醇（mmol/L）',
						suffixName: '',
						layoutType: 2,
						value: ''
					}
				],
				value: '',
				orderNum: 1,
				show: [
					{
						questionId: 'radio_9',
						answer: '是（含既往及本次随访期间新发现的血脂异常）'
					}
				]
			},
			{
				locationKey: 'radio_9_2',
				remark: '',
				mustAnswer: 1,
				questionType: '11',
				name: '9.2.您是否服用降脂药',
				optionList: [
					{
						name: '是',
						defaultFlag: 0
					},
					{
						name: '否',
						defaultFlag: 0
					}
				],
				layoutType: 1,
				value: '',
				show: [
					{
						questionId: 'radio_9',
						answer: '是（含既往及本次随访期间新发现的血脂异常）'
					}
				]
			},
			{
				locationKey: 'fuse_9_2_1',
				remark: '',
				mustAnswer: 1,
				questionType: '24',
				layoutType: 1,
				name: '9.2.1.您服用的降脂药',
				optionList: [
					[
						{
							name: '药物名称：',
							value: '',
							mustAnswer: 1,
							suffixName: ''
						},
						{
							name: '每次剂量：',
							value: '',
							mustAnswer: 0,
							suffixName: 'mg'
						},
						{
							name: '服药频率：',
							value: '',
							mustAnswer: 0,
							type: 'picker',
							columns: [1, 2, 3, 4],
							suffixName: '次/天'
						}
					]
				],
				value: [],
				orderNum: 3,
				show: [
					{
						questionId: 'radio_9_2',
						answer: '是'
					}
				]
			},
			{
				locationKey: 'checkbox_10',
				remark: '',
				mustAnswer: 1,
				questionType: '12',
				layoutType: 1,
				name: '10.您是否按医嘱坚持服用以下抗血小板药物（多选）',
				optionList: [
					{
						name: '阿司匹林',
						orderNum: 1,
						ext: [
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '每次剂量',
								suffixName: 'mg'
							},
							{
								type: 'picker',
								columns: [1, 2, 3, 4],
								value: '',
								mustAnswer: 0,
								label: '服药频率',
								suffixName: '次/天'
							}
						]
					},
					{
						name: '氯吡格雷',
						orderNum: 2,
						ext: [
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '每次剂量',
								suffixName: 'mg'
							},
							{
								type: 'picker',
								columns: [1, 2, 3, 4],
								value: '',
								mustAnswer: 0,
								label: '服药频率',
								suffixName: '次/天'
							}
						]
					},
					{
						name: '奥扎格雷',
						defaultFlag: 0,
						ext: [
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '每次剂量',
								suffixName: 'mg'
							},
							{
								type: 'picker',
								columns: [1, 2, 3, 4],
								value: '',
								mustAnswer: 0,
								label: '服药频率',
								suffixName: '次/天'
							}
						]
					},
					{
						name: '双嘧达莫',
						defaultFlag: 0,
						ext: [
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '每次剂量',
								suffixName: 'mg'
							},
							{
								type: 'picker',
								columns: [1, 2, 3, 4],
								value: '',
								mustAnswer: 0,
								label: '服药频率',
								suffixName: '次/天'
							}
						]
					},
					{
						name: '替格瑞洛',
						defaultFlag: 0,
						ext: [
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '每次剂量',
								suffixName: 'mg'
							},
							{
								type: 'picker',
								columns: [1, 2, 3, 4],
								value: '',
								mustAnswer: 0,
								label: '服药频率',
								suffixName: '次/天'
							}
						]
					},
					{
						name: '其他',
						defaultFlag: 0,
						ext: [
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '药品名称'
							},
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '每次剂量',
								suffixName: 'mg'
							},
							{
								type: 'picker',
								columns: [1, 2, 3, 4],
								value: '',
								mustAnswer: 0,
								label: '服药频率',
								suffixName: '次/天'
							}
						]
					},
					{
						name: '未服用',
						defaultFlag: 0,
						setting: {
							type: 'clear'
						}
					},
					{
						name: '医嘱未要求服用抗血小板药物',
						defaultFlag: 0,
						setting: {
							type: 'clear'
						}
					}
				],
				value: [],
				orderNum: 3,
				show: []
			},
			{
				locationKey: 'checkbox_11',
				remark: '',
				mustAnswer: 1,
				questionType: '12',
				layoutType: 1,
				name: '11.您是否按医嘱坚持服用以下抗凝药（多选）',
				optionList: [
					{
						name: '华法林',
						orderNum: 1,
						ext: [
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '每次剂量',
								suffixName: 'mg'
							},
							{
								type: 'picker',
								columns: [1, 2, 3, 4],
								value: '',
								mustAnswer: 0,
								label: '服药频率',
								suffixName: '次/天'
							}
						]
					},
					{
						name: '依度沙班',
						orderNum: 2,
						ext: [
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '每次剂量',
								suffixName: 'mg'
							},
							{
								type: 'picker',
								columns: [1, 2, 3, 4],
								value: '',
								mustAnswer: 0,
								label: '服药频率',
								suffixName: '次/天'
							}
						]
					},
					{
						name: '利伐沙班',
						defaultFlag: 0,
						ext: [
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '每次剂量',
								suffixName: 'mg'
							},
							{
								type: 'picker',
								columns: [1, 2, 3, 4],
								value: '',
								mustAnswer: 0,
								label: '服药频率',
								suffixName: '次/天'
							}
						]
					},
					{
						name: '阿哌沙班',
						defaultFlag: 0,
						ext: [
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '每次剂量',
								suffixName: 'mg'
							},
							{
								type: 'picker',
								columns: [1, 2, 3, 4],
								value: '',
								mustAnswer: 0,
								label: '服药频率',
								suffixName: '次/天'
							}
						]
					},
					{
						name: '达比加群',
						defaultFlag: 0,
						ext: [
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '每次剂量',
								suffixName: 'mg'
							},
							{
								type: 'picker',
								columns: [1, 2, 3, 4],
								value: '',
								mustAnswer: 0,
								label: '服药频率',
								suffixName: '次/天'
							}
						]
					},
					{
						name: '其他',
						defaultFlag: 0,
						ext: [
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '药品名称'
							},
							{
								type: 'input',
								value: '',
								mustAnswer: 0,
								label: '每次剂量',
								suffixName: 'mg'
							},
							{
								type: 'picker',
								columns: [1, 2, 3, 4],
								value: '',
								mustAnswer: 0,
								label: '服药频率',
								suffixName: '次/天'
							}
						]
					},
					{
						name: '未服用',
						defaultFlag: 0,
						setting: {
							type: 'clear'
						}
					},
					{
						name: '医嘱未要求服用抗凝药',
						defaultFlag: 0,
						setting: {
							type: 'clear'
						}
					}
				],
				value: [],
				orderNum: 3,
				show: []
			}
		]
	]
}
